// extracted by mini-css-extract-plugin
export default {"container":"SocialLogin_container__EAmHu","btn":"SocialLogin_btn__EFjqG","icon":"SocialLogin_icon__Vb9DL"};